import React, { useEffect, useState, useRef } from 'react';
import { Modal,Button} from "antd";
import Error from "../PublicViews/Error";
import InputMask from "react-input-mask";
import settings from "../../settings";
import FetchResponses from "../../models/FetchResponses";
import Auth from "../../models/Auth";

export const ModalConfirmarModificacionPlazo = ({
    openConfirmarModificacion,
    cancelConfirmarModificacion,
    fiscalNumber,
    logModification,
    cuota,
    newInterest,
    paymentPlan
}) => {
    const [loading, setLoading] = useState(false)
    const [phone, setPhone] = useState('');
    const [email, setEmail] = useState('');
    const [openOtpModal, setOpenOtpModal] = useState(false);
    const [openConfirmModal, setopenConfirmModal] = useState(false)
    const [openConfirmarGuardarCambio, setOpenConfirmarGuardarCambio] = useState(false)
    const [openError, setOpenError] = useState(false)
    const [errorMessage, setErrorMessage] = useState('')
    const [otp, setOtp] = useState(["", "", "", "", "", ""]);
    const inputRefs = useRef([]);
    const [timeLeft, setTimeLeft] = useState(0);
    const [intentosRestantes, setIntentosRestantes] = useState(0)
    const [title, setTitle] = useState("")
    const [closable, setClosable] = useState(false)
    const [customButton, setCustomButton] = useState(null)
    const [aceptaPolitica, setAceptaPolitica] = useState(false);
    
    
    useEffect(() => {
        setopenConfirmModal(openConfirmModal)
        setOpenOtpModal(false)
    }, [openConfirmarModificacion])
    
    
    const handleCheckboxChange = (event) => {
        setAceptaPolitica(event.target.checked);
        console.log("Acepta política:", event.target.checked);
    };
    
    const confirmarCambioPlazo = event => {
        event.preventDefault();
        setOpenOtpModal(false)
        setOtp(["", "", "", "", "", ""])
        setOpenConfirmarGuardarCambio(false)
        cancelConfirmarModificacion(true)
    }
    const cancelarCambioPlazo = event => {
        event.preventDefault();
        setOpenConfirmarGuardarCambio(false)
        setOpenOtpModal(false)
        cancelConfirmarModificacion()
    }

    const confirmarModificacionEnviarOtp = (e) => {
        e.preventDefault();

        setLoading(true)
        
        const data = {
            fiscal_number: fiscalNumber,
            all_data: false,
            log_modification:logModification
        }
        fetch(settings.backend.sendOtpModifyTerms, {
            method: 'POST',
            body: JSON.stringify(data),
            headers: settings.headers_super_auth,
        })
            .then(FetchResponses.processResponse)
            .then((res) => {
                setLoading(false)
                if(res.detail){
                    setOpenError(true)
                    setErrorMessage(res.detail)
                } else if(res.estado && res.estado === 'ERROR') {
                    setOpenError(true)
                    setErrorMessage(res.mensaje)   
                } else {
                    setOpenError(false)
                    setErrorMessage("")
                    setClosable(false)
                    setPhone(res.phone)
                    setEmail(res.email)
                    setTimeLeft(Number(res.vigencia_otp) * 60)
                    setIntentosRestantes(Number(res.intentos_restantes))
                    setopenConfirmModal(false)
                    setOpenOtpModal(true)
                }
            })
            .catch((err) => {
                setLoading(false)
                setOpenError(true)
                setErrorMessage('Error en el envio del código Otp')
            })
    };
 

    const enviarNotificacionConfirmacionOtp = () => {
        const url = `${settings.backend.sendNotificationModifyTerms}${fiscalNumber}/2`;
        fetch(url, {
            method: "GET",
            headers: settings.headers_auth(Auth.getSessionToken()) || settings.headers_super_auth,
        })
            .then(FetchResponses.processResponse)
            .then((data) => {
                console.log("Notification sent successfully:", data);
            })
            .catch((error) => {
                console.error("Error sending notification:", error);
            });
    };



    const closeModal = () => {
        setOtp(["", "", "", "", "", ""])
        cancelConfirmarModificacion()
    }

    const handleCloseError = (openOtp = false) =>{
        if(
            errorMessage === `Has agotado el número máximo de intentos. Verifica tus medios de contacto e inténtalo nuevamente.`
        ){
            cancelConfirmarModificacion()
            setOpenOtpModal(false)
        }else if(openOtp) {
            setOpenOtpModal(true)
        }
        setErrorMessage("")
        setOpenError(false)
        
    }


    const handleChange = (index, value) => {
        if (!/^[0-9]?$/.test(value)) return; // Permitir solo números
        const newOtp = [...otp];
        newOtp[index] = value;
        setOtp(newOtp);

        if (value && index < otp.length - 1) {
            inputRefs.current[index + 1].focus();
        }
    };

    const handleKeyDown = (index, event) => {
        if (event.key === "Backspace" && !otp[index] && index > 0) {
            inputRefs.current[index - 1].focus();
        }
    };

    const handlePaste = (event) => {
        event.preventDefault();
        const pasteData = event.clipboardData.getData("text").replace(/\D/g, "").slice(0, 6);
        const newOtp = pasteData.split("");
        while (newOtp.length < 6) newOtp.push("");
        setOtp(newOtp);
    };

    const isOtpComplete =  otp.every((digit) => digit !== "");

    const handleOtpSubmit =  () => {
        let otpCode = otp.join("");
        setLoading(true)

        const data = {
            "documento": fiscalNumber,
            "codigo": otpCode,
            'verificacion': true
        }
        fetch(settings.backend.validate_otp, {
            method: 'POST',
            body: JSON.stringify(data),
            headers: settings.headers_super_auth,
        })
            .then(FetchResponses.processResponse)
            .then((res) => {
                setLoading(false)
                if (res.estado.toUpperCase() === 'ERROR') {
                    setOpenOtpModal(false)
                    setOtp(["", "", "", "", "", ""])

                    setIntentosRestantes((prevTries) => {
                        const newTries = prevTries - 1;
                        if(newTries == 0) {
                            setOpenOtpModal(false)
                            cancelConfirmarModificacion()
                            setCustomButton({text: "Generar Nuevo Código", action: confirmarModificacionEnviarOtp})
                            setTitle("Intentos agotados")
                            setClosable(true)
                            setErrorMessage(`Has agotado el número máximo de intentos. Verifica tus medios de contacto e inténtalo nuevamente.`)
                        }else if(res.mensaje === "Código OTP invalido") {
                            setCustomButton({text: "Intentar de nuevo", action: () => { handleCloseError(true) }})
                            setTitle("Código incorrecto")
                            setClosable(false)
                            setErrorMessage(`El código ingresado no es válido. Por favor, verifica e inténtalo nuevamente. Tienes ${newTries} intentos disponibles`)
                        } else {
                            setClosable(false)
                            setErrorMessage(res.mensaje)
                        }
                        return newTries;
                    });

                    setOpenError(true)
                } else {
                    setOpenOtpModal(false)
                    setOpenConfirmarGuardarCambio(true)
                    enviarNotificacionConfirmacionOtp()
                }

            })
            .catch((err) => {
                setLoading(false)
                setErrorMessage('Error en el servicio e verificación del código OTP')
                setOpenError(true)
                setOtp(["", "", "", "", "", ""])
            })

    }

    useEffect(() => {
        if (timeLeft > 0) {
            const timer = setInterval(() => {
                setTimeLeft((prevTime) => prevTime - 1);
            }, 1000);
            return () => clearInterval(timer);
        }
    }, [timeLeft]);

    const formatTime = (seconds) => {
        const minutes = Math.floor(seconds / 60);
        const secs = seconds % 60;
        return `${minutes.toString().padStart(2, "0")}:${secs.toString().padStart(2, "0")}`;
    };

    return (
        <>

            <Modal
                visible={openConfirmarModificacion}
                onCancel={closeModal}
                closable={false}
                onClose={handleCloseError}
                footer={
                    loading ? (
                        <div className="d-flex justify-content-center">
                            <div className="spinner-border" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                        </div>

                    ) : (
                        [
                            <button
                                key="cancel"
                                className="btn btn-secondary"
                                onClick={()=>cancelConfirmarModificacion()}
                            >
                                Cancelar
                            </button>,
                            <button
                                key="confirm"
                                className="btn btn-primary"
                                type="button"
                                disabled={!aceptaPolitica}
                                onClick={confirmarModificacionEnviarOtp}
                            >
                                Continuar
                            </button>,
                        ]
                    )
                }
            >
                <div className="ant-confirm-body-wrapper">
                    <div className="ant-confirm-body">
                        <i className="anticon anticon-info-circle" />
                        <span className="ant-confirm-title">Confirma los términos de tu crédito</span>
                        <div className="ant-confirm-content">
                            <p className='mt-3 mb-2 '>
                                Para continuar con la modificación de cuotas de tu crédito, lee y acepta los siguientes términos y condiciones:
                            </p>
                            <p style={{ fontWeight: 'bolder'}}> Detalles de la modificación:</p>

                            <ul>
                                <li>Nuevo valor de la cuota: ${cuota} (según el resultado de la simulación).</li>
                                <li>Nuevo número de cuotas: {paymentPlan.length} (según lo que ingresaste). </li>
                                <li>Nueva tasa de interés: {Number(newInterest).toFixed(2) + ' % E.M.'} (sin IVA – la misma que aparece en la simulación).</li>
                            </ul>


                            <p>Consulta los  <a href='https://www.alkomprar.com/credito-20-minutos/legal' target="_blank" rel="noopener noreferrer" >términos y condiciones</a> completos</p>
                            
                            <div className="form-group">
                              <input
                                type="checkbox"
                                className="form-check-input"
                                id="AceptoPolitica"
                                required
                                checked={aceptaPolitica}
                                onChange={handleCheckboxChange}
                              />
                              {" "}
                              <label
                                className="form-check-label"
                                htmlFor="AceptoPolitica"
                              >
                                He leído y acepto los términos y condiciones.
                              </label>
                            </div>                   
                        </div>
                    </div>
                </div>
            </Modal>


            <Modal
                visible={openConfirmarGuardarCambio}
                onCancel={closeModal}
                closable={false}
                maskClosable={false}
                footer={
                    loading ? (
                        <div className="d-flex justify-content-center">
                            <div className="spinner-border" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                        </div>

                    ) : (
                        [
                            <button
                                key="cancel"
                                className="btn btn-secondary"
                                onClick={cancelarCambioPlazo}
                            >
                                Cancelar
                            </button>,
                            <button
                                key="confirm"
                                className="btn btn-primary"
                                type="button"
                                onClick={confirmarCambioPlazo}
                            >
                                Confirmar
                            </button>,
                        ]
                    )
                }
            >
                <div className="ant-confirm-body-wrapper">
                    <div className="ant-confirm-body">
                        <i className="anticon anticon-info-circle" />
                        <span className="ant-confirm-title">Alkomprar te informa.</span>
                        <div className="ant-confirm-content">
                            <p className='mt-3 mb-2 '> 
                                Con el ingreso del código OTP estas autorizando la modificación del plazo de tu crédito en caso 
                                querer continuar selecciona el botón CONFIRMAR , de lo contario selecciona la opción de CANCELAR .
                            </p>
                        </div>
                    </div>
                </div>
            </Modal>

            <Modal
                visible={openOtpModal}
                onCancel={closeModal}
                closable={true}
                footer={
                    loading ? (
                        <div className="d-flex justify-content-center">
                            <div className="spinner-border" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                        </div>

                    ) : null
                }
                centered
            >
                <div className="text-center">
                    <h5>Verifica tu identidad</h5>
                    <p className="text-muted">
                        Hemos enviado un código de seguridad (OTP) a tu celular o correo
                        registrado. Ingresa el código a continuación para continuar con el
                        proceso.
                    </p>
                    <div className="d-flex justify-content-center mb-3">
                        <span className="text-success me-5">📱 {phone}</span>
                        <span className="text-success">📧 {email}</span>
                    </div>
                    <div className="d-flex justify-content-center gap-2">
                        {otp.map((digit, index) => (
                            <input
                                key={index}
                                type="text"
                                maxLength="1"
                                className="form-control text-center"
                                style={{ width: "40px", height: "40px", fontSize: "1.5rem" }}
                                value={digit}
                                onChange={(e) => handleChange(index, e.target.value)}
                                onKeyDown={(e) => handleKeyDown(index, e)}
                                onPaste={handlePaste}
                                ref={(el) => (inputRefs.current[index] = el)}
                            />
                        ))}
                    </div>
                   {/*  <p className="text-muted mt-2">Tu código vence en <span className="text-danger">{ formatTime(timeLeft) }</span></p> */}
                    <button type="button" block className="m-2 btn btn-primary" disabled={loading || !isOtpComplete || timeLeft == 0} onClick={handleOtpSubmit}>
                        Validar Código
                    </button>
                    <button type="button" block className="m-2 btn btn-secondary" disabled={loading || timeLeft != 0} onClick={confirmarModificacionEnviarOtp}>
                        Generar Nuevo Código
                    </button>
                </div>
            </Modal>

            <Error
                open={openError}
                title={title}
                closable={closable}
                customButton={customButton}
                error_message={errorMessage}
                handleClose={handleCloseError}
                footer={
                    loading ? (
                        <div className="d-flex justify-content-center">
                            <div className="spinner-border" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                        </div>

                    ) : null
                }
            />
        </>

    );
};
